import React, { useState, useRef, useEffect } from 'react';
import { apiFetch } from '../utils/Api';

const AddCar = ({ onCarAdded }) => {
  const [showForm, setShowForm] = useState(false);
  const modalRef = useRef();
  const [formData, setFormData] = useState({
    id: '',
    merk: '',
    model: '',
    uitvoering: '',
    kenteken: '',
    gewicht: '',
    transmissie: '',
    aantalCilinders: '',
    carrosserie: '',
    aantalDeuren: '',
    pk: '',
    motorinhoud: '',
    kmstand: '',
    brandstof: '',
    kleur: '',
    interieurkleur: '',
    apk: '',
    omschrijving: '',
    opties: '',
    datum: '',
    prijs: '',
    aandrijving: '',
    aantalzitplaatsen: '',
    bekledingsoort: '',
    inOfEXBTW: '',
    verkocht: false
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowForm(false);
      }
    };

    if (showForm) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showForm]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const submitButton = e.target.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = true;
    }

    try {
      const processedData = {
        id: 0,
        merk: formData.merk || '',
        model: formData.model || '',
        uitvoering: formData.uitvoering || '',
        kenteken: formData.kenteken || '',
        gewicht: formData.gewicht ? parseInt(formData.gewicht) : 0,
        transmissie: formData.transmissie || '',
        aantalCilinders: formData.aantalCilinders ? parseInt(formData.aantalCilinders) : 0,
        carrosserie: formData.carrosserie || '',
        aantalDeuren: formData.aantalDeuren ? parseInt(formData.aantalDeuren) : 0,
        pk: formData.pk ? parseInt(formData.pk) : 0,
        motorinhoud: formData.motorinhoud ? parseInt(formData.motorinhoud) : 0,
        kmstand: formData.kmstand ? parseInt(formData.kmstand) : 0,
        brandstof: formData.brandstof || '',
        kleur: formData.kleur || '',
        interieurkleur: formData.interieurkleur || '',
        apk: formData.apk || '',
        omschrijving: formData.omschrijving || '',
        opties: formData.opties || '',
        datum: formData.datum || '',
        prijs: formData.prijs ? parseInt(formData.prijs) : 0,
        aandrijving: formData.aandrijving || '',
        aantalzitplaatsen: formData.aantalzitplaatsen ? parseInt(formData.aantalzitplaatsen) : 0,
        bekledingsoort: formData.bekledingsoort || '',
        inOfEXBTW: formData.inOfEXBTW || '',
        verkocht: formData.verkocht,
        imageLinks: []
      };

      const response = await apiFetch('/api/cars', {
        method: 'POST',
        body: JSON.stringify(processedData)
      });

      setFormData({
        merk: '',
        model: '',
        uitvoering: '',
        kenteken: '',
        gewicht: '',
        transmissie: '',
        aantalCilinders: '',
        carrosserie: '',
        aantalDeuren: '',
        pk: '',
        motorinhoud: '',
        kmstand: '',
        brandstof: '',
        kleur: '',
        interieurkleur: '',
        apk: '',
        omschrijving: '',
        opties: '',
        datum: '',
        prijs: '',
        aantalzitplaatsen: '',
        bekledingsoort: '',
        inOfEXBTW: '',
        verkocht: false
      });
      setShowForm(false);
      onCarAdded();
    } catch (error) {
      alert('Error adding car: ' + error.message);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  };

  return (
    <div>
      <button
        onClick={() => setShowForm(true)}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
      >
        Voeg Auto Toe
      </button>

      {showForm && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div ref={modalRef} className="relative top-10 mx-auto p-8 border w-3/4 max-w-4xl shadow-lg rounded-lg bg-white">
            <div className="absolute top-4 right-4">
              <button
                onClick={() => setShowForm(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <h2 className="text-2xl font-bold mb-6">Nieuwe Auto Toevoegen</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Merk</label>
                  <input
                    type="text"
                    name="merk"
                    value={formData.merk}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Model</label>
                  <input
                    type="text"
                    name="model"
                    value={formData.model}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Uitvoering</label>
                  <input
                    type="text"
                    name="uitvoering"
                    value={formData.uitvoering}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Kenteken</label>
                  <input
                    type="text"
                    name="kenteken"
                    value={formData.kenteken}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Gewicht (kg)</label>
                  <input
                    type="number"
                    name="gewicht"
                    value={formData.gewicht}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Transmissie</label>
                  <select
                    name="transmissie"
                    value={formData.transmissie}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="">Kies transmissie</option>
                    <option value="Automaat">Automaat</option>
                    <option value="Handgeschakeld">Handgeschakeld</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Aantal Cilinders</label>
                  <input
                    type="number"
                    name="aantalCilinders"
                    value={formData.aantalCilinders}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Carrosserie</label>
                  <select
                    name="carrosserie"
                    value={formData.carrosserie}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="">Kies carrosserie</option>
                    <option value="Hatchback">Hatchback</option>
                    <option value="Sedan">Sedan</option>
                    <option value="Stationwagen">Stationwagen</option>
                    <option value="SUV">SUV</option>
                    <option value="Coupé">Coupé</option>
                    <option value="Cabriolet">Cabriolet</option>
                    <option value="MPV">MPV</option>
                    <option value="Bestelbus">Bestelbus</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Aantal Deuren</label>
                  <input
                    type="number"
                    name="aantalDeuren"
                    value={formData.aantalDeuren}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">PK</label>
                  <input
                    type="number"
                    name="pk"
                    value={formData.pk}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Motorinhoud (cc)</label>
                  <input
                    type="number"
                    name="motorinhoud"
                    value={formData.motorinhoud}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Kmstand</label>
                  <input
                    type="number"
                    name="kmstand"
                    value={formData.kmstand}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Brandstof</label>
                  <select
                    name="brandstof"
                    value={formData.brandstof}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="">Kies brandstof</option>
                    <option value="Benzine">Benzine</option>
                    <option value="Diesel">Diesel</option>
                    <option value="Elektrisch">Elektrisch</option>
                    <option value="Hybride">Hybride</option>
                    <option value="LPG">LPG</option>
                    <option value="Waterstof">Waterstof</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Kleur</label>
                  <input
                    type="text"
                    name="kleur"
                    value={formData.kleur}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Interieurkleur</label>
                  <input
                    type="text"
                    name="interieurkleur"
                    value={formData.interieurkleur}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">APK</label>
                  <input
                    type="date"
                    name="apk"
                    value={formData.apk}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Datum</label>
                  <input
                    type="date"
                    name="datum"
                    value={formData.datum}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Prijs (€)</label>
                  <input
                    type="number"
                    name="prijs"
                    value={formData.prijs}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">BTW</label>
                  <select
                    name="inOfEXBTW"
                    value={formData.inOfEXBTW}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  >
                    <option value="">Kies BTW optie</option>
                    <option value="Inclusief">Inclusief BTW</option>
                    <option value="Exclusief">Exclusief BTW</option>
                    <option value="Marge">Marge</option>
                  </select>
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Aandrijving</label>
                  <input
                    type="text"
                    name="aandrijving"
                    value={formData.aandrijving}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Aantal zitplaatsen</label>
                  <input
                    type="number"
                    name="aantalzitplaatsen"
                    value={formData.aantalzitplaatsen}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">Bekledingsoort</label>
                  <input
                    type="text"
                    name="bekledingsoort"
                    value={formData.bekledingsoort}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  />
                </div>
                <div className="flex items-center mb-4">
                  <input
                    type="checkbox"
                    id="verkocht"
                    name="verkocht"
                    checked={formData.verkocht}
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 mr-2"
                  />
                  <label htmlFor="verkocht" className="text-gray-700 text-sm font-bold">Verkocht</label>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-gray-700 text-sm font-bold mb-2">Omschrijving</label>
                  <textarea
                    name="omschrijving"
                    value={formData.omschrijving}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    rows="4"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-gray-700 text-sm font-bold mb-2">Opties</label>
                  <textarea
                    name="opties"
                    value={formData.opties}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    rows="4"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-6 rounded-lg transition duration-200"
                >
                  Annuleren
                </button>
                <button
                  type="submit"
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-6 rounded-lg transition duration-200"
                >
                  Auto Toevoegen
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddCar;

